import {nError} from "../funcs";
import { isMissingDataError } from "./missingDataError";
import { markMissingFields } from "./scrollTo";

export function notifyUser(props: any, title: string, content: string = '') {
    props?.$commitToStore({
        notification: {
            title: title,
            content: content
        }
    })
}

export function notifyAboutError(props: any, error: any) {
    const e = nError(error)

    let title = e.notification.title
    if (title == "Токен истек, требуется обновление") {
        title = "Сессия истекла. Необходимо авторизоваться по номеру телефона заново"
    }

    if (isMissingDataError(error)) {
        markMissingFields(error.keywords)
    }
    
    props?.$commitToStore({
        notification: {
            title: title,
            content: e.notification.content as string,
            sticky: e.notification.sticky,
        }
    })
}

export function capitalize(str: string) {
    if (str.length == 0) {
        return str
    }
    return str[0].toUpperCase() + str.slice(1).toLowerCase();
}

export default notifyUser
